import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import PageMeta from '../components/PageMeta';
import Reveal from '../components/Reveal';
import { FinalCTA, PageHero, SectionHeading } from '../components/SharedSections';

const { FiCompass, FiTrendingUp, FiUnlock, FiLifeBuoy } = FiIcons;

function About() {
  const values = [[FiCompass, 'Unbiased recommendations', 'We begin with requirements and compare the market—not the other way around.'], [FiTrendingUp, 'Measurable ROI', 'Every recommendation must improve cost, capability, resilience, or team productivity.'], [FiUnlock, 'No vendor lock-in mindset', 'We favor flexibility, clear terms, and technology that can evolve with the business.'], [FiLifeBuoy, 'Support after the sale', 'We remain an escalation and optimization partner after implementation.']];

  return (
    <>
      <PageMeta title="About Cambia Digital" description="Meet the vendor-neutral technology advisor built on more than 20 years of B2B technology experience." />
      <PageHero eyebrow="About Cambia Digital" title="The advisor we wished every technology buyer had." text="Cambia was built on 20+ years of B2B technology sales experience—and a simple belief: growing businesses deserve informed options, not a one-provider pitch." />
      <section className="section">
        <div className="split-grid story-grid">
          <Reveal><SectionHeading eyebrow="Our story" title="Experience from inside the market. Advice centered on you." /></Reveal>
          <Reveal><p className="large-copy">Technology decisions get difficult when every vendor claims to be the best. We know how providers package, price, position, and implement their services. That experience helps us ask sharper questions, spot hidden tradeoffs, and turn a crowded market into a manageable decision.</p><p>We serve owners and IT and operations leaders across the NYC Tri-State area, with a strong local focus on Brooklyn and Queens.</p></Reveal>
        </div>
      </section>
      <section className="section tint">
        <Reveal><SectionHeading eyebrow="What guides us" title="Clear principles. Better technology decisions." center /></Reveal>
        <div className="card-grid four">
          {values.map(([icon, title, text]) => <Reveal className="solution-card" key={title}><div className="icon-tile"><SafeIcon icon={icon} /></div><h3>{title}</h3><p>{text}</p></Reveal>)}
        </div>
      </section>
      <FinalCTA />
    </>
  );
}

export default About;